/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
function sortBy() {
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');
      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
}
function collectionCTA() {
  var ctaContainers = document.querySelectorAll('.collection-inline-cta-container');
  ctaContainers.forEach(function (ctaContainer) {
    var number = parseInt(ctaContainer.getAttribute('data-cta-position'));
    var nthChild = document.querySelector('#collection-product-listing .product-card:nth-child(' + number + ')');
    if (typeof nthChild != 'undefined' && nthChild != null) {
      nthChild.insertAdjacentElement('afterend', ctaContainer);
    }
  });
}
function toggleFadeClass() {
  var collectionCollapsible = document.querySelectorAll('.collection-collapsible');
  collectionCollapsible.forEach(function (content) {
    var collectionDescription = content.querySelector('.collection-description');
    var readmoreBtn = content.querySelector('.collection-read-more');

    // Check if collectionDescription has overflow
    if (collectionDescription.scrollHeight > collectionDescription.clientHeight) {
      // collectionDescription has overflow
      readmoreBtn.classList.remove('hidden');
    } else {
      // collectionDescription does not have overflow
      readmoreBtn.classList.add('hidden');
    }
    if (typeof readmoreBtn != 'undefined' && readmoreBtn != null) {
      readmoreBtn.addEventListener('click', function () {
        if (collectionDescription.classList.contains('fade')) {
          collectionDescription.classList.remove('fade');
          readmoreBtn.textContent = 'Read Less';
        } else {
          collectionDescription.classList.add('fade');
          readmoreBtn.textContent = 'Read More';
        }
      });
    }
  });
}
sortBy();
collectionCTA();
toggleFadeClass();
/******/ })()
;